/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import Video, { type VideoProps } from 'components/Video/Video';
import './SpannedVideo.scss';

/**
 * This is the SpannedVideo component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function SpannedVideo(props: VideoProps) {
  return (
    <div className="block spanned-video">
      <Video {...props} scrollTo={{ alignTop: false, offset: 0 }} />
    </div>
  );
}

export default SpannedVideo;
